import { AbsoluteCenter, VStack } from '@chakra-ui/react';

import { Typography } from 'shared/components/Typography';

type ChatEmptyStateProps = {
  hasItems: boolean;
  children: React.ReactNode;
};

export const ChatMessagesEmptyState = ({
  hasItems,
  children,
}: ChatEmptyStateProps) => {
  return hasItems ? (
    <>{children}</>
  ) : (
    <AbsoluteCenter>
      <VStack>
        <Typography type="extraLargeHeading" textAlign="center">
          💬
        </Typography>
        <Typography
          type="heading"
          fontWeight="bold"
          color="black"
          textAlign="center"
        >
          It`s empty here
        </Typography>
        <Typography
          type="body"
          fontWeight="regular"
          color="gray"
          textAlign="center"
        >
          Be the first to start a conversation
        </Typography>
      </VStack>
    </AbsoluteCenter>
  );
};
